<template lang="pug">
div(:class="[$style.trustPilot, classes.join(' ')]")
  .text-center.inline-block(:style="css.length > 0 ? css.join(';') : 'width: auto'")
    img(
      loading="lazy"
      src="~/assets/img/trustpilot/brand/brandmark_gr-wht.svg"
      :class="[$style.lightLogo, 'fixed-size']"
      width="168"
      height="41"
      alt="Trustpilot")
    img(
      loading="lazy"
      src="~/assets/img/trustpilot/brand/brandmark_gr-blk.svg"
      :class="[$style.darkLogo, 'fixed-size']"
      width="168"
      height="41"
      alt="Trustpilot")
    img(
      loading="lazy"
      src="~/assets/img/trustpilot/brand/stars-4.5.svg"
      :class="[$style.rating, 'fixed-size']"
      width="168"
      height="31"
      alt="rating")
  .text-sm(v-if="trustpilotRating && trustpilotCustomers")
    span(v-html="ratingString")
    <br>
    a(
      v-show="readReviewsLink"
      :href="trustpilotURL"
      target="_blank"
      class="p-ds-md md:p-0") {{ &nbsp; $t('trustpilot.read')}}
</template>

<script lang="ts">
import { defineComponent } from "vue"
import TrustpilotBase from "~/components/base/trustpilotBase"

export default defineComponent({
  name: "Trustpilot",
  extends: TrustpilotBase,

  computed: {
    ratingString(): string {
      const locale = this.$i18n.locale || "en"

      const rating = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      }).format(this.trustpilotRating)

      const totalReviews = formatNumberWithLocale(this.trustpilotCustomers, this.$i18n.locale)
      const template = this.$t("trustpilot.rating").toString() + " Trustpilot"

      return template.replace("RATING", rating).replace("REVIEWCOUNT", totalReviews)
    }
  }
})
</script>

<style lang="scss" module>
@import "~/assets/scss/trustpilot.scss";
</style>
